import { produce } from 'immer'
import { valueIds } from '../constants/valueIds'
import { CoinShowerEvent } from '../model/BaseGameModel'
import { SymbolModel } from '../model/SymbolModel'
import { BLANK_SYMBOL } from '../constants/blankSymbol'

/**
 * Helper function to apply the hold and win transition to the reels.
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

/**
 * Immutably replace all non-value symbols with a placeholder and apply the transform to the reels.
 * @param reels 2D array of SymbolModel representing the reels
 * @param transformEvent Optional CoinShowerEvent containing the transforms to apply
 * @returns A new 2D array of SymbolModel with the hold and win transition applied
 */
export function applyHoldAndWinTransition(reels: SymbolModel[][], transformEvent?: CoinShowerEvent): SymbolModel[][] {
    return produce(reels, (draft) => {
        // Replace all non-value symbols with a placeholder
        for (let reel = 0; reel < draft.length; reel++) {
            for (let row = 0; row < draft[reel].length; row++) {
                if (!valueIds.includes(draft[reel][row].id)) {
                    draft[reel][row] = BLANK_SYMBOL
                }
            }
        }

        if (!transformEvent) {
            return
        }

        // Apply the transform to the reels
        for (const transform of transformEvent.transforms) {
            const [reel, row] = transform.position
            draft[reel][row] = transform.data
        }
    })
}
